import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import ClubCardState, { NormalizeClubCardState, NormalizeCustomerCodeState } from './types'

const setCustomerCodeState = (
  state: ClubCardState,
  customerCodeState: NormalizeCustomerCodeState,
): ClubCardState => ({
  ...state,
  ...customerCodeState,
})

const toggleClubCardDrawer = (state: ClubCardState): ClubCardState => ({
  ...state,
  isClubCardDrawerOpen: !state.isClubCardDrawerOpen,
})

const setClubCardPropsToState = (
  state: ClubCardState,
  clubCardState: NormalizeClubCardState,
): ClubCardState => ({
  ...state,
  ...clubCardState,
  failedToLoad: false,
})

const setClubCardFail = (state: ClubCardState): ClubCardState => ({
  ...state,
  failedToLoad: true,
})

const reducer = createReducer<ClubCardState>((on) => {
  on(actions.setCustomerCodeState, setCustomerCodeState)
  on(actions.toggleClubCardDrawer, toggleClubCardDrawer)
  on(actions.setClubCardPropsToState, setClubCardPropsToState)
  on(actions.setClubCardFail, setClubCardFail)
}, initialState)

export default reducer
